module.exports = __webpack_public_path__ + "img/Warehouse.44d7e16c.png";